import {Chip, Paper, Typography} from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2"
import {useTranslation} from "react-i18next"
import {Stack} from "@mui/system"
import {lightGreenBackgroundColor, fontFamilyMuseo700} from "../../mui/Theme"
import {Color} from "../../utils/assets/ColorFromFiability"
import {displayPriceToFixed} from "../../utils/helpers/LocalPrice"
import {BboxCluster} from "../../utils/model/BboxResult"

interface Props {
    cluster: BboxCluster;
    onClusterClick: (cluster: BboxCluster) => void;
}

const GMapCluster = ({cluster, onClusterClick}: Props) => {
    const {t} = useTranslation();

    const onClick = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        onClusterClick(cluster);
    }

    const hasPrice = cluster.price > 0;
    const fiabilityColor = Color.forFiabilityLevel(cluster.fiability);
    const border = hasPrice ? 2 : 0;
    const background = cluster.isCheapest ? lightGreenBackgroundColor : "white";
    const displayCount = cluster.pointCountLabel < 99 ? cluster.pointCountLabel.toString() : '99+';
    const chipColor = cluster.isCheapest ? "success" : "primary";

    return (
        <div onClick={onClick} className={"cluster"}>
            <div className="cluster-inner">
                <Paper elevation={12} sx={{
                    background: background,
                    p: 0.4,
                    borderRadius: '32px',
                    border: border,
                    borderColor: fiabilityColor
                }}>
                    <Grid container gap={0.5} wrap='nowrap' alignItems={'center'}>
                        <Grid>
                            <Chip label={displayCount}
                                  onClick={onClick}
                                  color={chipColor}
                                  sx={{
                                      fontSize: 14,
                                      fontFamily: fontFamilyMuseo700,
                                  }}
                            />
                        </Grid>
                        {hasPrice &&
                            <Stack mr={0.75} gap={0.2}>
                                <Typography mb={0} fontSize={10} noWrap lineHeight={1}>
                                    {t('cheapestPrice')}
                                </Typography>
                                <Stack direction={'row'} alignItems={'flex-end'} gap={0.25}>
                                    <Typography fontSize={14} fontFamily={fontFamilyMuseo700} lineHeight={1.2}>
                                        {displayPriceToFixed(cluster.price)}
                                    </Typography>
                                </Stack>
                            </Stack>
                        }
                    </Grid>
                </Paper>
            </div>
        </div>
    )
}

export default GMapCluster
